import React, { useEffect, useState } from "react";
import Success from "./components/Success/Success";
import EMIsAPI from "../../services/emi-api";
import Failed from "./components/Failed/Failed";
import { handleShowContextualLoader, handlehideContextualLoader } from "../../utils/contextualLoaderTrigger";

export default function RepaymentStatus() {
  const [data, setData] = useState(null);

  useEffect(() => {
    const getRozarPayOrder = async () => {
      const { rozarpayOrderStatusAPI } = new EMIsAPI();
      const res = await rozarpayOrderStatusAPI();

      if (res.statusCode === 200) {
        setData(res.data);
      }
    };

    getRozarPayOrder();
  }, []);

  // console.log("data------------", data);

  useEffect(() => {
    if (!data) {
      handleShowContextualLoader("Please wait...");
    } else {
      handlehideContextualLoader();
    }
    return () => {
      handlehideContextualLoader();
    };
  }, [data]);

  if (!data) {
    return null;
  }
  return (
    <>
      {data.razorpayData.status === "paid" ? <Success data={data.razorpayData} /> : <Failed data={data.razorpayData} />}
    </>
  );
}
